import { render, staticRenderFns } from "./customer-complaint.vue?vue&type=template&id=6f559012&scoped=true&"
import script from "./customer-complaint.vue?vue&type=script&lang=js&"
export * from "./customer-complaint.vue?vue&type=script&lang=js&"
import style0 from "./customer-complaint.vue?vue&type=style&index=0&id=6f559012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f559012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f559012')) {
      api.createRecord('6f559012', component.options)
    } else {
      api.reload('6f559012', component.options)
    }
    module.hot.accept("./customer-complaint.vue?vue&type=template&id=6f559012&scoped=true&", function () {
      api.rerender('6f559012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/customer-complaint.vue"
export default component.exports